export const BASE = '/';

export const WELCOME = '/welcome';

export const SIGN_IN = '/signin';
export const SIGN_UP = '/signup'
export const SIGN_OUT = '/signout';

export const BONUS_PROGRAM = '/bonus/program';

export const BONUS = '/bonus';
export const BONUS_EXCHANGE = '/bonus/exchange';

export const PROFILE = '/profile';

export const PREVIEW = '/preview';

